import { Component, ViewChild, Injector, Output, EventEmitter, ElementRef, ViewEncapsulation, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap';
import { AppComponentBase } from '@shared/common/app-component-base';
import { RegistrationsServiceProxy, RegistrationDto, CancelRegistrationInput, } from '@shared/service-proxies/service-proxies';
import { SubscriptionSituationType } from '@shared/AppEnums';

@Component({
    selector: 'cancelModal',
    templateUrl: './cancel-modal.component.html'
})

export class  CancelModalComponent extends AppComponentBase {

    subscriptionSituationType = SubscriptionSituationType

    @ViewChild('createOrEditModal') modal: ModalDirective;    
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;
    
    registration: RegistrationDto = new RegistrationDto();
    situation = undefined;

    constructor(
        injector: Injector,
        private _registrationsService: RegistrationsServiceProxy
        
    ) {
        super(injector);        
    }

    ngAfterViewChecked(): void {
        //Temporary fix for: https://github.com/valor-software/ngx-bootstrap/issues/1508
        $('tabset ul.nav').addClass('m-tabs-line');
        $('tabset ul.nav li a.nav-link').addClass('m-tabs__link');
    }
    
    close(): void {
        this.active = false;
        this.modal.hide();
    }

    onShown(): void {
        this.modal.show();        
    }    

    public show(registration: RegistrationDto): void {        
        
        this.active = true;        
        this.registration = registration;  
        this.situation = undefined;      
        this.modal.show();
    }    

    save(): void {
                
        let msg = "";

        if(this.situation == SubscriptionSituationType.CancelledByDivergence)
        {
            msg = this.l('Are you sure cancel by divergence the registration of the {0}?', this.registration.user.name);
        }
        else {
            msg = this.l('Are you sure cancel by user request the registration of the {0}?', this.registration.user.name);            
        }

        msg += ' ' + this.l('If net amount of the payment charge is bigger than zero will be created a new payment charge in Payable.');
        
        let input = new CancelRegistrationInput();
        input.registrationId = this.registration.id;
        input.situation = this.situation;

        this.message.confirm(
            msg,
            (isConfirmed) => {
                if (isConfirmed) {
                this._registrationsService.cancel(input)
                    .subscribe(() => {
                        this.notify.info(this.l('SavedSuccessfully'));
                        this.close();
                        this.modalSave.emit(null);
                    });
                }
            }
        );
        
    }
}



// WEBPACK FOOTER //
// ./src/app/event/registrations/modals/cancel/cancel-modal.component.ts